<!--  -->
<template>
  <div>
    <div class="hzuse_box">
      <div class="dasdnum">
        转盘格数：
      </div>
      <div>
        <el-radio-group v-model="radio" @change="numcaher">
          <el-radio :label="4">4个</el-radio>
          <!-- <el-radio :label="6">6个</el-radio>
          <el-radio :label="8">8个</el-radio> -->
        </el-radio-group>
      </div>
    </div>
    <div class="hzuse_box">
      <div class="dasdnum">
        转盘标题：
      </div>
      <div>
        <el-input v-model="alltitle" style="width:400px" placeholder="请输入内容" />
      </div>
    </div>
    <!-- <div class="hzuse_box">
      <div class="dasdnum">
        背景图片地址：
      </div>
      <div>
        <el-input v-model="bgpic" style="width:400px" placeholder="请输入内容" />
      </div>
    </div> -->
    <div class="hzuse_box">
      <div class="dasdnum">
        客服链接：
      </div>
      <div>
        <el-input v-model="link" style="width:400px" placeholder="请输入内容" />
      </div>
    </div>
    <div class="hzuse_box">
      <div class="dasdnum">
        玩法说明：
      </div>
      <div style="width:400px">
        <el-input
          v-model="explain"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
        />
      </div>
    </div>
    <div class="hzuse_box">
      <div class="dasdnum">
        每日抽奖次数：
      </div>
      <div>
        <el-input v-model="daily" style="width:400px" placeholder="请输入内容" />
      </div>
    </div>

    <div class="hzuse_box">
      <div class="dasdnum">
        立即抽奖次数：
      </div>
      <div>
        <el-input v-model="immediately" style="width:400px" placeholder="请输入内容" />
      </div>
    </div>

    <div class="hzuse_box">
      <div class="dasdnum">
        书币兑换门槛(普通用户)：
      </div>
      <div>
        <el-input v-model="ordinary" style="width:400px" placeholder="请输入内容" />
      </div>
    </div>

    <div class="hzuse_box">
      <div class="dasdnum">
        书币兑换门槛(vip用户)：
      </div>
      <div>
        <el-input v-model="vipordinary" style="width:400px" placeholder="请输入内容" />
      </div>
    </div>

    <div class="hzuse_box">
      <div class="dasdnum">
        每月最多兑换次数：
      </div>
      <div>
        <el-input v-model="mostnum" style="width:400px" placeholder="请输入内容" />
      </div>
    </div>
    <div class="idpada_box">
      <div v-for="item,index in updata" :key="index">
        <div class="sdaf_bdew">
          <div class="serialnumber">
            {{ index + 1 }}
          </div>

          <div class="hzuse_box">
            <div class="dasdnumr">
              上传图片：
            </div>
            <div>
              <!-- <el-button type="primary" size="mini" @click="$refs.file[index].click()">上传<input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPictures($event,index)"></el-button> -->
              <div>
                <!-- @click="$refs.file[index].click()" 去掉的 -->
                <el-image
                  class="idawupdataimg"
                  :src="item.img"
                  :fit="'contain'"
                />
                <input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPictures($event,index)">
              </div>
            </div>
          </div>
          <div class="hzuse_box">
            <div style="margin-left:15px">
              标题：
            </div>
            <div>
              <el-input v-model="item.name" disabled placeholder="请输入内容" />
            </div>
          </div>
          <div class="hzuse_box">
            <div style="margin-left:15px">
              概率：
            </div>
            <div>
              <el-input v-model="item.probability" placeholder="请输入内容" />
            </div>
          </div>
          <div class="hzuse_box">
            <div style="margin-left:15px">
              书币数量：
            </div>
            <div>
              <el-input v-model="item.bookCurrency" disabled placeholder="请输入内容" />
            </div>
          </div>
        </div>

      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitclick">确 定</el-button>
    </span>
  </div>
</template>

<script>
import { qiniuToken } from '@/api/qiniuToken.js'
import { newMaterial, createturntableconfig, updataturntableconfig } from '@/api/sourceMaterial.js'
import * as qiniu from 'qiniu-js'
export default {
  components: {},
  data() {
    return {
      updata: [], // 渲染数量数组
      token: null, // 上传图片token
      picupdataindex: null, // 上传图片index
      radio: 4, // 转盘数量
      num: 0, // 概率校验
      alltitle: '', // 标题
      // bgpic: '', // 背景图片地址
      link: '', // 链接
      explain: '', // 玩法说明
      daily: '', // 每日抽奖次数
      immediately: '', // 立即抽奖次数
      ordinary: '', // 书币兑换门槛(普通用户)
      vipordinary: '', // 书币兑换门槛(vip用户)
      mostnum: '', // 每月最多兑换次数

      zhengdata: [],
      type: null, // 新增 编辑类型
      ids: null// 编辑的id
    }
  },
  created() {
    this.numcaher(this.radio)
    this.getQiniuToken()
  },
  mounted() {

  },
  methods: {
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },

    numcaher(val) {
      console.log('val', val)
      const arr = []
      this.updata = []
      for (let i = 0; i < val; i++) {
        arr.push({
          // img: 'https://ziyuan.jingxuansz.com/user/xsishg--500coin.png', // 图片显示
          // picture: 377, // 要传图片的id
          // name: '', // 标题
          probability: '' // 概率
          // bookCurrency: ''// 书币个数
        })
      }
      arr[0].bookCurrency = 5
      arr[1].bookCurrency = 10
      arr[2].bookCurrency = 30
      arr[3].bookCurrency = 50
      arr[0].name = '5书币'
      arr[1].name = '10书币'
      arr[2].name = '30书币'
      arr[3].name = '50书币'
      arr[0].img = require('@/assets/larke/5coin.png')
      arr[1].img = require('@/assets/larke/10coin.png')
      arr[2].img = require('@/assets/larke/30coin.png')
      arr[3].img = require('@/assets/larke/50coin.png')
      this.updata = arr
      console.log(arr, arr)
    },
    async uploadPictures(e, index) {
      console.log(e.target.files[0], index)
      this.picupdataindex = index
      const fileIfon = e.target.files[0]
      const img = new Image()
      // const temporary = window.URL.createObjectURL(fileIfon)
      // img.src = temporary
      // this.updata[this.picupdataindex].img = temporary
      const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
        fname: fileIfon.name // 文件名
      }, {
        useCdnDomain: true // cdn域名加速
      })
      observable.subscribe({
        next() { },
        error(err) {
          console.log(err)
        },
        complete: (data) => {
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          console.log('data', data)
          newMaterial({
            type: 1,
            height: img.height,
            width: img.width,
            size: fileIfon.size,
            key: data.key
          }).then(res => {
            console.log('res', res)
            this.updata[this.picupdataindex].img = res.data.path
            this.updata[this.picupdataindex].picture = res.data.sourceMaterialId
          })
        }

      })
    },
    async submitclick() {
      console.log('this.updata', this.updata)

      const data = this.updata.map((item1) => {
        return { name: item1.name, probability: item1.probability, bookCurrency: item1.bookCurrency, picture: item1.picture }
      })
      this.zhengdata = data
      console.log('JSON.stringify(this.zhengdata)', JSON.stringify(this.zhengdata))
      if (this.alltitle === '') {
        this.$message.error('请填写转盘标题')
        return
      }
      // if (this.bgpic === '') {
      //   this.$message.error('请填写背景图片地址')
      //   return
      // }
      if (this.link === '') {
        this.$message.error('请填写客服链接')
        return
      }
      if (this.explain === '') {
        this.$message.error('请填写玩法说明')
        return
      }
      if (this.daily === '') {
        this.$message.error('请填写每日抽奖次数')
        return
      }
      if (this.immediately === '') {
        this.$message.error('请填写立即抽奖次数')
        return
      }
      if (this.ordinary === '') {
        this.$message.error('请填写书币兑换门槛(普通用户)')
        return
      }
      if (this.vipordinary === '') {
        this.$message.error('请填写书币兑换门槛(vip用户)')
        return
      }
      if (this.mostnum === '') {
        this.$message.error('请填写每月最多兑换次数')
        return
      }

      const isTrue = this.updata.every(function(v, i, arr) {
        return v.name !== ''
      })
      if (isTrue === false) {
        this.$message.error('请填写标题')
        return
      }
      const isTruer = this.updata.every(function(v, i, arr) {
        return v.probability !== ''
      })
      if (isTruer === false) {
        this.$message.error('请填写概率')
        return
      }
      this.num = 0
      this.updata.forEach(item => {
        this.num += Number(item.probability)
      })
      // eslint-disable-next-line eqeqeq
      if (this.num != 100) {
        this.$message.error('概率加一起要总共为100%')
        return
      }
      const isTruere = this.updata.every(function(v, i, arr) {
        return v.bookCurrency !== ''
      })
      if (isTruere === false) {
        this.$message.error('请填写书币数量')
        return
      }
      if (this.type === 1) {
        const datar = await createturntableconfig({
          title: this.alltitle,
          // backgroundPic: this.bgpic,
          customer_service_url: this.link,
          play_instructions: this.explain.replace(/\n/g, '<br/>'),
          // prize: JSON.stringify(this.zhengdata),
          prize: this.zhengdata,
          raffle_number: this.daily,
          immediately_number: this.immediately,
          book_currency_exchange: this.ordinary,
          book_currency_exchange_vip: this.vipordinary,
          exchange_number: this.mostnum
        })
        this.$message({
          message: '新增成功',
          type: 'success'
        })
        this.$emit('close')
        console.log('datar', datar)
      } else {
        const datarr = await updataturntableconfig({
          title: this.alltitle,
          // backgroundPic: this.bgpic,
          customer_service_url: this.link,
          play_instructions: this.explain.replace(/\n/g, '<br>'),
          prize: this.zhengdata,
          raffle_number: this.daily,
          immediately_number: this.immediately,
          book_currency_exchange: this.ordinary,
          book_currency_exchange_vip: this.vipordinary,
          exchange_number: this.mostnum,
          id: this.ids
        })
        this.$message({
          message: '更新成功',
          type: 'success'
        })
        this.$emit('close')
        console.log('编辑', datarr)
      }

      // console.log('num', this.num)
    },
    send(val, item) {
      console.log('传', val)
      this.type = val
      if (val === 1) {
        console.log('新增')
      } else {
        console.log('编辑', item, item.prize.length)
        this.radio = item.prize.length
        this.ids = item.id
        item.prize[0].img = require('@/assets/larke/5coin.png')
        item.prize[1].img = require('@/assets/larke/10coin.png')
        item.prize[2].img = require('@/assets/larke/30coin.png')
        item.prize[3].img = require('@/assets/larke/50coin.png')
        this.updata = item.prize
        this.alltitle = item.title
        this.link = item.customer_service_url
        this.explain = item.play_instructions.replace(/<br>/g, '\n')
        this.daily = item.raffle_number
        this.immediately = item.immediately_number
        this.ordinary = item.book_currency_exchange
        this.vipordinary = item.book_currency_exchange_vip
        this.mostnum = item.exchange_number
      }
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
.hzuse_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.dasdnum{
  font-size: 15px;
  color: #606266;
  width: 180px;
  text-align: right;
}
.dasdnumr{
  font-size: 15px;
  color: #606266;
  width: 76px;
  text-align: right;
}
.sdaf_bdew{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.idawupdataimg{
  width: 60px;
  height: 80px;
}
.idpada_box{
  height: 480px;
  overflow: scroll;
  overflow-x:hidden
}
.idpada_box::-webkit-scrollbar {
    width: 10px;
    background-color: #fff;
}
.idpada_box:hover ::-webkit-scrollbar-track-piece {
   /*鼠标移动上去再显示滚动条*/
    background-color: #fff;
    /* 滚动条的背景颜色 */
    border-radius: 6px;
    /* 滚动条的圆角宽度 */
}

.idpada_box:hover::-webkit-scrollbar-thumb:hover {
    background-color: #c0cecc;
}
.idpada_box:hover::-webkit-scrollbar-thumb:vertical {
    background-color: #ccc;
    border-radius: 6px;
    outline: 2px solid #fff;
    outline-offset: -2px;
    border: 2px solid #fff;
}
.serialnumber{
    padding-bottom: 18px;
    font-size: 17px;
    margin-right: 10px;
}
/deep/ .el-textarea__inner{
  min-height: 100px !important;
}

</style>
